const truthy = (value: string | undefined) => /^(1|true|yes|on)$/i.test(value?.trim() || '')

export function isMarketingPublicMode() {
  return truthy(process.env.NEXT_PUBLIC_FEATURE_MARKETING_ONLY) &&
    truthy(process.env.NEXT_PUBLIC_FEATURE_PUBLIC_PORTFOLIOS)
}

export function isPublicPortfolioRead(pathname: string, method: string) {
  if (method !== 'GET' && method !== 'HEAD') return false
  // Match complete public routes; never open the authenticated portfolio editor.
  if (/^\/api\/portfolio\/story(?:\/|$)/.test(pathname)) return false
  return /^\/portfolio\/[a-zA-Z0-9-]+(?:\/case\/[a-zA-Z0-9-]+)?\/?$/.test(pathname) ||
    /^\/case\/public\/[a-zA-Z0-9-]+\/?$/.test(pathname) ||
    /^\/api\/portfolio\/[a-zA-Z0-9-]+(?:\/case\/[a-zA-Z0-9-]+)?(?:\/metadata)?\/?$/.test(pathname) ||
    /^\/api\/public\/[a-zA-Z0-9-]+(?:\/metadata)?\/?$/.test(pathname)
}
